/**
 * THE ARTICLES AREA'S WORDS OUTSIDE A COMPONENT (design 29, W5). A helper that returns words takes the
 * screen's `t` (`useTranslation('articles')`), so a language change redraws what it said. Where a
 * caller hands none - a spec calling the helper bare - the current language's is read at the call,
 * never when a module loads.
 */
import type { ParseKeys, TFunction } from 'i18next';
import { i18n } from '../../i18n';

/** The `articles` namespace's translate function, as `useTranslation('articles')` hands it out. */
export type ArticlesT = TFunction<'articles'>;

/** A key of the `articles` namespace, for a table that names its words by key. */
export type ArticlesKey = ParseKeys<'articles'>;

/** The `articles` translate function in the cabinet's language right now. */
export function articlesT(): ArticlesT {
  return i18n.getFixedT(null, 'articles');
}
